import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Card, CardBody, Row, Col,
} from 'reactstrap';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { ClubResources } from '@alumni-ventures-group/react-shared/lib/services';
import { doSignIn } from '../../../../shared/services/authActions';
import navigateToResetPasswordHandler from '../../common/navigateToResetPasswordHandler';
import LoginForm from '../../../../shared/components/LoginForm';

const { blueColor } = ClubResources;

const navigatingToResetPassword = () => navigateToResetPasswordHandler();

const LoginCard = ({
  dispatch, existingEmail, switchScreen, history,
}) => {
  const [loginError, setLoginError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [captchaError, setCaptchaError] = useState('');
  const { executeRecaptcha } = useGoogleReCaptcha();

  if (navigatingToResetPassword()) {
    switchScreen(true);
  }

  const handleFormSubmit = async (data) => {
    if (!executeRecaptcha) {
      return;
    }

    const { email, password } = data;
    setLoading(true);
    try {
      const reCaptchaToken = await executeRecaptcha('login');

      const signInRes = await doSignIn(dispatch, {
        email,
        password,
        reCaptchaToken,
      });
      if (signInRes && signInRes.success === false) {
        if (signInRes.code === 429){
          setCaptchaError(signInRes.message);
          setLoginError(false);
        }
        else if (signInRes.message !== '[500]') {
          setLoginError(true);
          setCaptchaError('');
        }
      } else {
        setLoginError(false);
        setCaptchaError('');
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      if (error && error.message !== '[500]') {
        setLoginError(true);
      }
    } finally {
      setLoading(false);
    }
  };

  const url = new URL(window.location.href);
  const sessionTimeout = url.searchParams.get('session_timeout');

  return (
    <Card className="card--not-full-height">
      <CardBody>
        <Row className="w-100">
          <Col>
            <h3>
              <b style={{ color: blueColor.main }}>
                Investor Login
              </b>
            </h3>
            <h5>
              Login to Alumni Ventures
            </h5>
          </Col>
        </Row>
        <hr />
        {sessionTimeout && (
        <span style={{ color: '#AC2929' }}>
          Session expired. Please log in again to continue.
        </span>
        )}
        <LoginForm
          handleFormSubmit={handleFormSubmit}
          loginError={loginError}
          captchaError={captchaError}
          existingEmail={existingEmail}
          switchScreen={switchScreen}
          loading={loading}
        />
      </CardBody>
    </Card>
  );
};

LoginCard.propTypes = {
  dispatch: PropTypes.func.isRequired,
  existingEmail: PropTypes.string,
  switchScreen: PropTypes.func,
  // eslint-disable-next-line react/forbid-prop-types, react/require-default-props
  history: PropTypes.any,
};

LoginCard.defaultProps = {
  existingEmail: '',
  switchScreen: null,
};

const mapStateToProps = (state) => ({
  dispatch: state.auth,
});

export default withRouter(connect(mapStateToProps)(LoginCard));
